export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const THIRTY_DAYS_MS = 1000 * 60 * 60 * 24 * 30;
export const EIGHT_HOURS_MS = 1000 * 60 * 60 * 8;
/** Re-issue session cookie when more than 50% of lifetime has elapsed */
export const SLIDING_WINDOW_THRESHOLD = 0.5;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';
